<!-- BaseSelect.vue (client) -->
<template tag="클라이언트 선택 컴포넌트">
  <component
    :is="isAuto ? 'v-autocomplete' : 'v-select'"
    v-model="selectedValue"
    :items="options ?? []"
    item-title="label"
    item-value="value"
    density="compact"
    variant="outlined"
    :class="['form_style select_box', size ? size : '', !border ? 'border_none' : '']"
    :menu-props="{ contentClass: `combobox_overlay select_overlay ${size ? size : ''}` }"
    :placeholder="placeholder || $text('common.all')"
    :disabled="disabled"
    no-data-text="No Result"
    :error-messages="errorMessages"
  ></component>
</template>

<script setup lang="ts">
import { defineProps, type PropType, onMounted } from "vue";

/* ------------------------------------------------------------
                          Vue Instance & Global Properties
   ------------------------------------------------------------ */
import { i18n } from "@/common/plugins/global";
const { $text } = i18n();

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const selectedValue = defineModel<string | number | null>();

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps({
  placeholder: { type: String, default: "" },
  options: {
    type: Array as PropType<{ label: string; value: string }[]>,
    default: () => [],
  },
  size: { type: String, default: "" },
  border: { type: Boolean, default: true },
  disabled: { type: Boolean, default: false },
  errorMessages: { type: Array as PropType<string[]>, default: () => [] },
  isAuto: { type: Boolean, default: false },
});

/* ------------------------------------------------------------
                          Methods
   ------------------------------------------------------------ */
/** 기본값 설정 */
function getDefaultValue() {
  return props.placeholder ? null : (props.options[0]?.value ?? null);
}

/* ------------------------------------------------------------
                          Lifecycle
   ------------------------------------------------------------ */
onMounted(() => {
  selectedValue.value = getDefaultValue();
});
</script>
